import { Controller } from "@hotwired/stimulus"

// Lesson-page copy of the course disclaimer. sessionStorage keeps the dismiss
// for this tab's visit so Next does not reopen it; a new tab starts fresh.
export default class extends Controller {
  static values = { courseId: Number }

  connect() {
    if (this.dismissed()) this.element.remove()
  }

  dismiss() {
    this.persist()
    this.element.remove()
  }

  dismissed() {
    try {
      return sessionStorage.getItem(this.storageKey) === "1"
    } catch {
      return false
    }
  }

  persist() {
    try {
      sessionStorage.setItem(this.storageKey, "1")
    } catch {
      // Private mode can reject sessionStorage; the banner still closes here.
    }
  }

  get storageKey() {
    return `tms.academy.courseDisclaimerDismissed.${this.courseIdValue}`
  }
}
